import { useState } from 'react';
import { GetDischargePlanResponse } from '~/store/services/clinical-data/dischargePlan';
import { DiscardChangesModalContextProvider } from '../common/DiscardChangesModalContext';
import AddEditAftercareOrReferralsModal from '../modals/AddEditAftercareReferralsModal';
import ReferralsAndFollowUpAppointmentsSection from './ReferralsAndFollowUpAppointmentsSection';
import AftercareRecommendationsSection from './AftercareRecommendationsSection';
import { AftercareAndReferralsSectionField } from './section-cards';

interface AftercareAndReferralsSectionsProps {
  dischargePlanData?: GetDischargePlanResponse;
}

const AftercareAndReferralsSections = ({
  dischargePlanData,
}: AftercareAndReferralsSectionsProps) => {
  const [selectedFieldName, setSelectedFieldName] =
    useState<AftercareAndReferralsSectionField | null>(null);

  return (
    <DiscardChangesModalContextProvider
      onCloseModal={() => setSelectedFieldName(null)}
    >
      <AftercareRecommendationsSection
        dischargePlanData={dischargePlanData}
        onSelectField={setSelectedFieldName}
      />
      <ReferralsAndFollowUpAppointmentsSection
        dischargePlanData={dischargePlanData}
        onSelectField={setSelectedFieldName}
      />
      <AddEditAftercareOrReferralsModal
        dischargePlanId={dischargePlanData?.id}
        fieldLabel={selectedFieldName?.editorLabel}
        fieldName={selectedFieldName?.key}
        initialValue={dischargePlanData?.[selectedFieldName?.key] ?? null}
        isOpen={!!selectedFieldName}
        placeholderText={selectedFieldName?.placeholderText}
      />
    </DiscardChangesModalContextProvider>
  );
};

export default AftercareAndReferralsSections;
